const focus = {
  mounted(el){
    el.focus()
   }
}

export default focus
